import makeStyles from 'e100-react-components/lib/styles/makeStyles';
import { STATION_MODAL_Z_INDEX } from 'common/constants/styles';

interface StyleProps {
  left?: number;
  isMobile: boolean;
}

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    boxShadow: '0px 1px 5px 0px #6372822E, 0px 3px 4px 0px #6372821A, 0px 2px 4px 0px #6372821F',
    width: '100%',
    maxWidth: '400px',
    zIndex: 1000,
    position: 'fixed',
    left: (props: StyleProps) => props.left ?? spacing(9),
    top: 0,
    bottom: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  dialogRoot: {
    // @ts-ignore
    zIndex: `${STATION_MODAL_Z_INDEX} !important` as number,
  },
  dialogRootPartMobile: {
    inset: 'auto !important',
    bottom: '0 !important',
    width: '100%',
    height: 'auto',
  },
  contentRootMobile: {
    borderBottomWidth: 0,
    paddingBottom: 0,
  },
  titleRoot: {
    paddingBottom: 0,
    boxShadow: ({ isMobile }: StyleProps) => (isMobile ? 'none' : undefined),
    '& h2': {
      '& > button': {
        display: 'none',
      },
    },
    '& button': {
      top: spacing(),
      right: spacing(),
    },
  },
  contentRoot: {
    borderTopWidth: 0,
  },
  titleArrowButton: {
    top: `${spacing(-0.5)}px !important`,
  },
  container: {
    height: 'calc(100% - 100px)',
    width: '100%',
    overflow: 'auto',
  },
}));
